import React from "react";
import AccessoryFormModal from "../../generatedFormModal/AccessoryFormModal";

const AddAccessory = () => {
  return (
    <div>
      <AccessoryFormModal isEdit={false} />
    </div>
  );
};

export default AddAccessory;
